// removed by extract-text-webpack-plugin
module.exports = {"versionSnippet":"_1mrrB8fkvlzk7vdTecfOZC","active":"_3ZUGOV3gqFsBdpC04DVH","date":"o2qgr3ac3jyA1xW29oY4x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VersionSnippet/VersionSnippet.scss
// module id = 830
// module chunks = 0